import React, {Component, Fragment} from "react";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import {defaultTableChange} from "../../../../modules/custom/customTable";
import FlexView from "react-flexview";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleInput from "../../../../modules/SimpleInput";
import PenyerahanBBNLeasingDetailFilter from "./penyerahanBBNLeasingDetailFilter";
import {tableColumns} from "./config";
import {getValueFromDDL, removeNullFields} from "../../../common/mapper";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import SimpleCheckBox from "../../../../modules/SimpleCheckBox";
import * as R from "ramda";
import {filterDataTable} from "./util";

class PenyerahanBBNLeasingDetail extends Component {
    constructor(props) {
        super(props);
        this.initialSearch = {
            stnkName: null,
        };
        this.initialFilterData = {
            facture: null,
            startPeriod: null,
            endPeriod: null,
            bookNumber: null,
            kodeVariant: null,
            kodeWarna: null,
            stnkName: null,
            buyer: null,
            frameNumber: null,
            engineNumber: null,
            numberBPKB: null,
            pencairan: null,
        };
        this.state = {
            loading: false,
            filterModalVisible: false,
            search: this.initialSearch,
            filterData: this.initialFilterData,
            tableColumns: [
                ...tableColumns.thirdPage,
                {
                    name: "bpkbStatus",
                    label: "Action",
                    options: {
                        customBodyRender: (val, tableMeta) => {
                            return (
                                <FlexView vAlignContent="center" style={{gap: 10}}>
                                    <SimpleCheckBox
                                        id="checkbox_action_on_submission_detail"
                                        checked={R.equals(val, "Received")}
                                        onChange={(e) => this.props.handleCheckedDetail(tableMeta.rowIndex, e)}
                                    />
                                </FlexView>
                            );
                        },
                        sort: false,
                    },
                },
            ],
            dataTable: [],
            dataRollBackTable: [],
            pagination: {
                page: 1,
                limit: 5,
                totalData: 0,
            },
        }
    }

    handleModalFilterVisibility = () => {
        this.setState((prevState) => ({
            ...prevState,
            filterModalVisible: !prevState.filterModalVisible,
        }));
    };

    handleClose = () => {
        this.props.handleRollBackDetail();
        this.props.onClickClose();
    }

    handleValueChangeSearch = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            search: {
                ...prevValue.search,
                [name]: value,
            },
        }));
    };

    handleClearSearch = () => {
        this.setState((prevState) => ({
            ...prevState,
            search: this.initialSearch,
        }));
    }

    handleReset = () => {
        this.setState((prevState) => ({
            ...prevState,
            search: this.initialSearch,
            filterData: this.initialFilterData,
        }));
        this.props.handleResetDetail();
    }

    handleSubmitSearch = async () => {
        this.handleTriggerLoading();
        let filters = {...removeNullFields(this.parseFilterData(this.state.search))}
        let filteredData = filterDataTable(this.props.dataTableChanged, filters)
        this.props.handleSubmitSearchDetail(filteredData)
        this.handleClearFilter();
        this.handleTriggerLoading();
    }

    handleFilterValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                [name]: value,
            },
        }));
    };

    handleClearFilter = () => {
        this.setState((prevState) => ({
            ...prevState,
            filterData: this.initialFilterData,
        }));
    }

    handleOnSubmitFilter = async () => {
        this.handleTriggerLoading()
        let filters = {...removeNullFields(this.parseFilterData(this.state.filterData))}
        let filteredData = filterDataTable(this.props.dataTableChanged, filters)
        this.props.handleSubmitSearchDetail(filteredData)
        this.handleClearSearch();
        this.handleModalFilterVisibility();
        this.handleTriggerLoading()
    }

    parseFilterData(data) {
        return {
            ...data,
            kodeCabang: getValueFromDDL(data, "kodeCabang"),
            pencairan: getValueFromDDL(data, "pencairan"),
            kodeVariant: data["kodeVariant"]?.map((item) => item.value),
            kodeWarna: data["kodeWarna"]?.map((item) => item.value),
        };
    }

    handleSubmit = () => {
        this.props.onSubmitDetail(this.props.dataTable);
    }

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

     handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        const {pagination} = this.state;
        return (
            <Fragment>
                <SimpleModal
                    title="Detail Penyerahan BBN Pelanggan"
                    visible={this.props.visible}
                    onClickClose={() => this.handleClose()}
                    content={
                        <ModalContainer>
                            <FlexView vAlignContent="center" hAlignContent="right" style={{marginBottom: "20px"}}>
                                <SimpleInput
                                    type="text"
                                    name="stnkName"
                                    placeholder="Nama STNK"
                                    containerclassname="margin-bottom-none"
                                    value={this.state.search.stnkName}
                                    onChange={(e) => this.handleValueChangeSearch(e.target.name, e.target.value)}
                                />
                                <SimpleButton
                                    text="Cari"
                                    onClick={this.handleSubmitSearch}
                                    className="margin-top-5px"
                                />
                                <SimpleButton
                                    text="Reset"
                                    onClick={this.handleReset}
                                    className="margin-top-5px"
                                />
                                <SimpleButton
                                    className={"btn background-red margin-top-5px"}
                                    styles={{width: "unset"}}
                                    onClick={this.handleModalFilterVisibility}
                                    icon={<i className="fa fa-qrcode"></i>}
                                />
                            </FlexView>

                            <SimpleDataTable
                                key={`${this.props.dataTable?.length}-${pagination.page}`}
                                data={this.props.dataTable}
                                columns={this.state.tableColumns}
                                toCount={this.props.dataTable?.length}
                                rowsPerPage={pagination.limit}
                                page={pagination.page - 1}
                                options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
                            />

                            <FlexView hAlignContent={"right"} style={{marginTop: "20px"}}>
                                <SimpleButton
                                    type="button"
                                    text="Simpan"
                                    onClick={() => this.handleSubmit()}
                                />
                            </FlexView>
                        </ModalContainer>
                    }
                />

                {this.state.filterModalVisible && (
                    <PenyerahanBBNLeasingDetailFilter
                        filterData={this.state.filterData}
                        visible={this.state.filterModalVisible}
                        onValueChange={this.handleFilterValueChange}
                        onSubmit={this.handleOnSubmitFilter}
                        onClearForm={this.handleClearFilter}
                        onClickClose={this.handleModalFilterVisibility}
                    />
                )}

                <SimpleLoadingOverlay active={this.state.loading}/>
            </Fragment>
        )
    }
}

export default PenyerahanBBNLeasingDetail;